module.exports = __webpack_public_path__ + "static/img/three_down_ar.583669a4.png";